module.exports = __webpack_public_path__ + "media/images/up-357ec0c84b08387eb301e71d9f261743.svg";